<template id="modal-box-template">
    <!-- Modal -->
    <div
        :class="classname"
        class="modal fade"
        id="formModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="ModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
    >
        <div
            class="modal-overlay"
            data-dismiss="modal"
            aria-label="Close"
            @click="hideModal"
        ></div>
        <div class="modal-dialog" :class="computedModalSize" role="document">
            <div class="modal-content">
                <div
                    v-if="['contractcheckoutform', 'formpagesupdate', 'insertmedia', 'updatemedia', 'baseselectimage', 'formsendresponse'].includes(classname)"
                    class="modal-header d-flex flex-row justify-content-between"
                >
                    <div class="modal-header-texts-wrapper">
                        <h5
                            v-if="title"
                            class="modal-title title01"
                            id="ModalLabel"
                        >
                            {{ title }}
                        </h5>

                        <slot name="modalreader"> </slot>
                    </div>

                    <button
                        @click="hideModal"
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body">
                    <slot name="modalcontent"></slot>
                </div>
                <!-- <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="hideModal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
            </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ModalElement",
    props: {
        title: {
            type: String,
            required: false,
        },
        classname: {
            type: String,
            required: false,
        },
        indicate: {
            type: String,
            required: false,
        },
        hidemodalfunction: {
            type: Function,
            required: false,
        },
    },
    data: () => {
        return {
            modalsize: "",
        };
    },
    mounted() {
        //Set Modal Size
        this.setDynamicModalSize(this.classname);
    },
    methods: {
        hideModal() {
            switch (this.indicate) {
                case "pdp":
                    this.hidemodalfunction(this.classname);

                    break;
            }

            return $("." + this.classname).modal("hide");
        },
        setDynamicModalSize(classname) {
            switch (classname) {
                case "baseselectimage":
                    this.modalsize = "modal-xl";
                    break;

                case "pdpeditmodal":
                    this.modalsize = " modal-dialog-centered";
                    break;

                default:
                    this.modalsize = "modal-lg modal-dialog-centered";
                    break;
            }

            return this.modalsize;
        },
    },
    computed: {
        computedModalSize() {
            return this.modalsize;
        },
    },
    watch: {
        computedModalSize() {},
    },
};
</script>
